import React from 'react'
import PropTypes from 'prop-types'

import { isCredibleDate } from 'common/date'
import moment from 'moment'

import Icon from '@scoir/components-core/dist/components/Icon'
import { Link } from 'components/CalendarDestinationLink'

import dateRangeIcon from 'icons/date-range.svg'

import './VisitsAvailableCell.scss'

class VisitsAvailableCell extends React.Component {
  getFocus(availabilityDate) {
    return moment(availabilityDate).format('YYYYMMDD')
  }

  render() {
    return (
      <div className="visits-available-cell-comp">
        {isCredibleDate(this.props.visitAvailability) ? (
          <Link
            highSchoolId={this.props.highSchoolId}
            highSchoolName={this.props.highSchoolName}
            to={`${import.meta.env.BASE_URL}/recruit/visits/view/week?focus=${this.getFocus(
              this.props.visitAvailability,
            )}`}
          >
            <Icon
              def={dateRangeIcon}
              beforeText
            ></Icon>
            <span className="availability-date">{moment(this.props.visitAvailability).format('MMM DD, YYYY')}</span>
          </Link>
        ) : (
          <span>No Availability</span>
        )}
      </div>
    )
  }
}

VisitsAvailableCell.propTypes = {
  visitAvailability: PropTypes.string.isRequired,
  highSchoolId: PropTypes.string.isRequired,
  highSchoolName: PropTypes.string.isRequired,
}

export default VisitsAvailableCell
